import Group from 'components/utils/Group'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { EmptyArray, groupBy } from 'lib/array/arrayUtils'
import React, { useMemo } from 'react'
import { getAvailablePackagesByRoom, PackagesOptionsViewsByRoom } from 'selectors/offerPage/multipleRoomBookingSelectors'
import Pane from 'components/Common/Pane'
import MobileMultipleRoomsSameRoomOption from './MobileMultipleRoomsSameRoomOption'

interface Props {
  rooms: Array<App.RoomOccupants>;
  availablePackagesByRoom: PackagesOptionsViewsByRoom;
}

function MobileMultipleRoomsSameRoomContent(props: Props) {
  const { rooms, availablePackagesByRoom } = props
  const availablePackages = availablePackagesByRoom[rooms[0].roomId]
  const optionsByRoomType = useMemo(() =>
    Array
      .from(groupBy(availablePackages, (pkg) => pkg?.package.roomType?.id).values())
      // Order by availability of rooms in the room type from having the most to the least
      .sort((a, b) => ((b[0].availableRooms ?? 0) - rooms.length) - ((a[0].availableRooms ?? 0) - rooms.length)),
  [availablePackages, rooms.length])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {optionsByRoomType.map((roomOptions) => <MobileMultipleRoomsSameRoomOption
          key={roomOptions[0].package.roomType?.id}
          packageOptions={roomOptions}
        />)}
      </Group>
    </Pane>
  )
}

type MappedProps = Pick<Props,
  'rooms'
  | 'availablePackagesByRoom'
>

export default withOfferPageAndReduxState((state, appState): MappedProps => ({
  rooms: state.rooms ?? EmptyArray as Array<App.RoomOccupants>,
  availablePackagesByRoom: getAvailablePackagesByRoom(state, appState),
}), MobileMultipleRoomsSameRoomContent)
